<script setup lang="ts"></script>

<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="80" height="80" viewBox="0 0 80 80" fill="none">
    <circle cx="40" cy="40" r="33.3333" fill="#F2BA00" stroke="#FA7E25" stroke-width="3.33333" />
    <rect x="23.3359" y="30" width="10" height="13.3333" rx="5" fill="#813612" />
    <rect x="25" y="36.668" width="5" height="5" rx="2.5" fill="white" />
    <rect x="46.6641" y="30" width="10" height="13.3333" rx="5" fill="#813612" />
    <rect x="48.3359" y="36.668" width="5" height="5" rx="2.5" fill="white" />
    <path
      d="M34.1641 58.5447C35.8059 57.3636 37.8204 56.668 39.9974 56.668C42.1744 56.668 44.1889 57.3636 45.8307 58.5447"
      stroke="#813612"
      stroke-width="5"
      stroke-linecap="round"
    />
  </svg>
</template>
